import templateUrl from './listview.tpl.html';
import './table/listview-table';
import './exports-table/component';
import './grid/listview-grid';
import './pagination/listview-pagination';
import './filters/listview-filters';
import './keyword-search/keyword-search';
import '../../stats/components/guestlists/general/component'

angular
    .module('festzelt-os.components')
    .component('listview', {
        bindings: {
            store: '=',
            parent: '='
        },
        controller: [
            '$scope',
            function ($scope) {
                this.$onInit = () => {
                    this.lodash = _;
                    this.showStats = false;
                    this.store.commit('setBusy', true);
                    this.store.ng.injector.get('$rootScope').$emit('tableIsLoading', true);
                    this.store.dispatch('registerPusherListeners');
                    this.store.dispatch('getDefinitions').then(() => {
                        this.store.dispatch('getData').then(() => {
                            this.store.ng.injector.get('$rootScope').$emit('tableIsLoading', false);
                            this.showStats = true
                        });
                    });
                    this.store.dispatch('publishHighlightActions');
                }

                this.$onDestroy = () => {
                    this.store.dispatch('unregisterPusherListeners');
                }

                this.search = (keyword) => {
                    this.store.dispatch('searchKeyword', keyword)
                }

                this.toggleStats = () => {
                    this.showStats = !this.showStats;
                }

                this.refreshData = () => {
                    this.store.ng.injector.get('$rootScope').$emit('tableIsLoading', true);
                    this.store.commit('setRefresh', true);
                    this.store.dispatch('getData').then(() => {
                        this.store.ng.injector.get('$rootScope').$emit('tableIsLoading', false)
                    });
                }
            }
        ],
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/listview.js